import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

import { PickId } from '../../../../core/picks/pick-id';

@Component({
    selector: 'bs-digital-single-bet-pick-stake-keyboard',
    templateUrl: './single-bet-pick-stake-keyboard.component.html',
    styleUrls: ['./single-bet-pick-stake-keyboard.component.scss'],
    // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export default class SingleBetPickStakeKeyboardComponent {
    @Input() pickId: PickId;
    @HostBinding('class') className = 'single-bet-pick-stake-keyboard';
}
